import { elements, modifiers } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import { render } from '#utilities/js/template/template.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import mutations from '@mailobj-browser/front/js/tree/mutations.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import array from '@mailobj-browser/front/js/utils/array.js'

const options = {
  attributes: true,
  attributeFilter: array(['disabled'])
}

export default input => {
  queueMicrotask(async () => {
    const records = mutations(input, options, removed(input))

    for await (const record of records) {
      if (input.disabled === false && input.value !== 'FR') {
        const fields = closest(`.${elements.new_fields}`, input)
        const birthdeptControl = one(`input[name="info_birthdept"]`, fields)
        const birthdeptField = closest(`.${elements.new_field}`, birthdeptControl)

        birthdeptField.disabled = true
        birthdeptControl.disabled = true
        birthdeptField.classList.add(utilities.modifiers.display.none)
      }
    }
  })
}
